import { build } from '@jackfranklin/test-data-bot'

import type { GetKybResponse } from './types'

export const getKybResponseBuilder = build<GetKybResponse>({
  fields: {
    steps: [
      {
        code: 'BUSINESS_DETAILS',
        label: 'Business details',
        status: 'DONE',
      },
      {
        code: 'ACCOUNT_REQUESTER_DETAILS',
        label: 'Account requester details',
        status: 'DONE',
      },
      {
        code: 'LEGAL_REPRESENTATIVE_DETAILS',
        label: 'Legal representative details',
        status: 'TODO',
      },
      {
        code: 'PRIMARY_BENEFICIAL_OWNER_DETAILS',
        label: 'Primary beneficial owner details',
        status: 'TODO',
      },
      {
        code: 'LETTER_OF_AUTHORIZATION',
        label: 'Letter of authorization',
        status: 'TODO',
      },
      {
        code: 'REVIEW',
        label: 'Review and submit',
        status: 'TODO',
      },
    ],
    data: {
      business: {
        legalName: 'Back Market Technologies SAS',
        tradeName: 'Back Market',
        email: 'info@backmarket.com',
        countryOfRegistration: 'FR',
        registrationType: 'SAS',
        registrationNumber: '123456789',
        incorporationDate: '2009-09-01',
        headquartersAddress: {
          addressLine1: '123 Main Street',
          addressLine2: 'Suite 456',
          postalCode: '75001',
          city: 'Paris',
          country: 'FR',
        },
        branchesAddresses: [
          {
            addressLine1: '123 Main Street',
            addressLine2: 'Suite 456',
            postalCode: '33000',
            city: 'Bordeaux',
            country: 'FR',
          },
        ],
        articleOfIncorporation: [],
        w9: [],
        registeredBusinessAddress: {
          addressLine1: '123 Main Street',
          addressLine2: 'Suite 456',
          postalCode: '75001',
          city: 'Paris',
          country: 'FR',
        },
        investedCapital: {
          currency: 'EUR',
          amount: 1000000,
        },
      },
      accountRequester: {
        id: '123e4567-e89b-12d3-a456-426614174000',
        firstName: 'John',
        kanaFirstName: 'ジョン',
        latinFirstName: 'John',
        lastName: 'Doe',
        kanaLastName: 'ドウ',
        latinLastName: 'Doe',
        dateOfBirth: '1990-01-15',
        countryOfCitizenship: 'FR',
        phoneNumber: '+33123456789',
        countryOfResidency: 'FR',
        countryOfBirth: 'FR',
        address: {
          addressLine1: '123 Main Street',
          addressLine2: 'Suite 456',
          postalCode: '75001',
          city: 'Paris',
          country: 'FR',
        },
        identityDocument: {
          countryOfIssue: 'FR',
          front: 'id-front.pdf',
          back: 'id-back.pdf',
        },
      },
      legalRepresentative: {
        sameAsAccountRequester: false,
        id: '223e4567-e89b-12d3-a456-426614174001',
        firstName: 'Jane',
        kanaFirstName: 'ジェーン',
        latinFirstName: 'Jane',
        lastName: 'Smith',
        kanaLastName: 'スミス',
        latinLastName: 'Smith',
        dateOfBirth: '1985-03-20',
        countryOfCitizenship: 'FR',
        phoneNumber: '+33987654321',
        countryOfResidency: 'FR',
        countryOfBirth: 'FR',
        address: {
          addressLine1: '456 Other Street',
          postalCode: '69000',
          city: 'Lyon',
          country: 'FR',
        },
        identityDocument: {
          countryOfIssue: 'FR',
          front: 'legal-rep-front.pdf',
          back: 'legal-rep-back.pdf',
        },
      },
      beneficialOwner: {
        primary: {
          sameAsAccountRequester: false,
          sameAsLegalRepresentative: false,
          id: '323e4567-e89b-12d3-a456-426614174002',
          firstName: 'Robert',
          lastName: 'Johnson',
          dateOfBirth: '1980-07-10',
          countryOfCitizenship: 'FR',
          phoneNumber: '+33111222333',
          countryOfResidency: 'FR',
          countryOfBirth: 'FR',
          address: {
            addressLine1: '789 Another Street',
            postalCode: '13000',
            city: 'Marseille',
            country: 'FR',
          },
          identityDocument: {
            identificationType: 'PASSPORT',
            countryOfIssue: 'FR',
            front: 'id-front.pdf',
            back: 'id-back.pdf',
          },
        },
        secondary: [
          {
            id: '423e4567-e89b-12d3-a456-426614174003',
            firstName: 'Maria',
            lastName: 'Garcia',
            dateOfBirth: '1992-11-25',
            countryOfCitizenship: 'ES',
            phoneNumber: '+34999888777',
            countryOfResidency: 'ES',
            countryOfBirth: 'ES',
            address: {
              addressLine1: '987 Madrid Street',
              postalCode: '28001',
              city: 'Madrid',
              country: 'ES',
            },
            identityDocument: {
              identificationType: 'PASSPORT',
              countryOfIssue: 'ES',
              front: 'id-front.pdf',
              back: 'id-back.pdf',
            },
          },
        ],
      },
      letterOfAuthorization: null,
    },
    errors: [],
  },
})

// Convenience builders for common test scenarios
export const getKybResponseWithAllStepsCompletedBuilder = () =>
  getKybResponseBuilder({
    overrides: {
      steps: [
        {
          code: 'BUSINESS_DETAILS',
          label: 'Business details',
          status: 'DONE',
        },
        {
          code: 'ACCOUNT_REQUESTER_DETAILS',
          label: 'Account requester details',
          status: 'DONE',
        },
        {
          code: 'LEGAL_REPRESENTATIVE_DETAILS',
          label: 'Legal representative details',
          status: 'DONE',
        },
        {
          code: 'PRIMARY_BENEFICIAL_OWNER_DETAILS',
          label: 'Primary beneficial owner details',
          status: 'DONE',
        },
        {
          code: 'LETTER_OF_AUTHORIZATION',
          label: 'Letter of authorization',
          status: 'DONE',
        },
      ],
    },
  })
